var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container error-container"},[_c(_setup.Alert,{attrs:{"message":_setup.props.error.message,"variant":"error"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }